(() => {
  "use strict";
  class SodiumCorrectionCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";
      const root = this;
      // ---------- fluid library ----------
        var FLUIDS = [
          {id:"nacl3",   name:"3% NaCl (hypertonic)",            na:513, k:0,  use:"Symptomatic hyponatraemia (raise Na⁺)"},
          {id:"nacl09",  name:"0.9% NaCl (normal saline)",       na:154, k:0,  use:"Hyponatraemia; general resus"},
          {id:"plasma",  name:"Plasma-Lyte 148 / Normosol-R",    na:140, k:5,  use:"Balanced maintenance/replacement"},
          {id:"hartmann",name:"Hartmann's / Lactated Ringer's",  na:131, k:5,  use:"Balanced replacement"},
          {id:"nacl045", name:"0.45% NaCl (half-strength)",       na:77,  k:0,  use:"Hypernatraemia (lower Na⁺)"},
          {id:"nacl045d",name:"0.45% NaCl + 2.5% dextrose",       na:77,  k:0,  use:"Hypernatraemia + free water"},
          {id:"n18d4",   name:"0.18% NaCl + 4% dextrose",         na:30,  k:0,  use:"Free-water replacement"},
          {id:"d5w",     name:"5% dextrose in water (D5W)",       na:0,   k:0,  use:"Pure free water (hypernatraemia)"}
        ];

        var SPECIES = {
          dog:{low:140, high:152, label:"Dog", refLow:140, refHigh:155},
          cat:{low:147, high:162, label:"Cat", refLow:147, refHigh:162}
        };

        // ---------- state ----------
        var state = {
          species:"dog",
          acuity:"chronic",
          gluUnit:"mmol",
          fluid:"nacl045"
        };

        // ---------- element refs ----------
        var $ = function(id){return root.querySelector("#" + id);};
        var weightEl=$("weight"), naEl=$("na"), gluEl=$("glucose"),
            tbwfEl=$("tbwf"), hoursEl=$("hours"), targetEl=$("targetOverride"),
            fluidEl=$("fluid"), outEl=$("output"),
            flagLipid=$("flagLipid"), flagProt=$("flagProt");

        // populate fluid dropdown + reference table
        (function initFluids(){
          var opt="", ref="";
          FLUIDS.forEach(function(f){
            opt+='<option value="'+f.id+'">'+f.name+' — Na⁺ '+f.na+'</option>';
            ref+='<tr><td>'+f.name+'</td><td>'+f.na+'</td><td>'+f.k+'</td><td>'+f.use+'</td></tr>';
          });
          fluidEl.innerHTML=opt;
          fluidEl.value=state.fluid;
          $("fluidRef").innerHTML=ref;
        })();

        function fluidById(id){for(var i=0;i<FLUIDS.length;i++){if(FLUIDS[i].id===id)return FLUIDS[i];}return FLUIDS[0];}

        // ---------- segmented controls ----------
        function bindSeg(containerId, key, cb){
          var c=$(containerId);
          c.addEventListener("click",function(e){
            var b=e.target.closest("button"); if(!b)return;
            [].forEach.call(c.querySelectorAll("button"),function(x){x.classList.remove("active");});
            b.classList.add("active");
            state[key]=b.getAttribute("data-v");
            if(cb)cb();
            render();
          });
        }
        bindSeg("species","species", function(){ /* update default fluid suggestion not forced */ });
        bindSeg("acuity","acuity");

        // glucose unit toggle
        $("gluUnit").addEventListener("click",function(e){
          var b=e.target.closest("button"); if(!b)return;
          [].forEach.call(this.querySelectorAll("button"),function(x){x.classList.remove("active");});
          b.classList.add("active");
          state.gluUnit=b.getAttribute("data-u");
          render();
        });

        [weightEl,naEl,gluEl,tbwfEl,hoursEl,targetEl,fluidEl,flagLipid,flagProt].forEach(function(el){
          el.addEventListener("input",render);
          el.addEventListener("change",render);
        });

        // ---------- helpers ----------
        function num(el){var v=parseFloat(el.value);return isNaN(v)?null:v;}
        function fmt(v,d){if(v===null||v===undefined||isNaN(v))return "–";return Number(v).toFixed(d===undefined?1:d);}
        function fmtSigned(v,d){var s=fmt(Math.abs(v),d);return (v>=0?"+":"−")+s;}

        // ---------- main render ----------
        function render(){
          var sp=SPECIES[state.species];
          var w=num(weightEl), na=num(naEl), tbwf=num(tbwfEl)||0.6;
          var hours=num(hoursEl)||24;
          state.fluid=fluidEl.value;

          if(w===null||na===null||w<=0){
            outEl.innerHTML=''+
              '<div class="verdict v-neutral"><div class="tag">Waiting for input</div>'+
              '<div class="big">Enter weight &amp; Na⁺</div>'+
              '<div class="desc">Results update live as you type.</div></div>';
            return;
          }

          var TBW = w*tbwf; // litres

          // glucose correction
          var glu=num(gluEl), gluMmol=null, corrNa=na, gluAdd=0;
          if(glu!==null && glu>0){
            gluMmol = state.gluUnit==="mgdl" ? glu/18.0 : glu;
            if(gluMmol>5.5){
              gluAdd = 1.6*((gluMmol-5.5)/5.6);
              corrNa = na + gluAdd;
            }
          }

          // classification uses corrected Na
          var evalNa = corrNa;
          var status, sevText, vClass, sevWord;
          if(evalNa < sp.low){
            status="hypo";
            var dHypo = sp.low - evalNa;
            sevWord = evalNa<120?"Severe":evalNa<130?"Moderate":"Mild";
            vClass = evalNa<120?"v-danger":evalNa<130?"v-warn":"v-warn";
            sevText = sevWord+" hyponatraemia";
          } else if(evalNa > sp.high){
            status="hyper";
            sevWord = evalNa>180?"Severe":evalNa>170?"Moderate":"Mild";
            vClass = evalNa>180?"v-danger":"v-warn";
            sevText = sevWord+" hypernatraemia";
          } else {
            status="normal";
            vClass="v-ok";
            sevText="Sodium within reference range";
          }

          // ---- build verdict block ----
          var html="";
          var corrLine = (gluAdd>0)
            ? '<div class="desc">Measured '+fmt(na)+' → <strong>glucose-corrected '+fmt(corrNa)+' mmol/L</strong> (+'+fmt(gluAdd)+' for glucose '+fmt(gluMmol)+' mmol/L). Assessment uses the corrected value.</div>'
            : '<div class="desc">'+sp.label+' reference used: '+sp.low+'–'+sp.high+' mmol/L. '+(glu!==null&&glu>0?'Glucose normal — no correction applied.':'')+'</div>';

          html+='<div class="verdict '+vClass+'">'+
                '<div class="tag">'+sp.label+' · '+(status==="normal"?"Normal":sevText)+'</div>'+
                '<div class="big">'+fmt(evalNa)+' mmol/L</div>'+
                corrLine+'</div>';

          // ---- pseudohyponatraemia note ----
          if(status==="hypo" && (flagLipid.checked||flagProt.checked)){
            html+='<div class="callout amber"><strong>Check for pseudohyponatraemia first.</strong> You have flagged '+
              (flagLipid.checked&&flagProt.checked?"lipaemia and hyperproteinaemia":flagLipid.checked?"marked lipaemia":"marked hyperproteinaemia")+
              '. With an indirect (diluted) ISE analyser this can falsely lower reported Na⁺ while true plasma Na⁺ is normal. Confirm with a <strong>direct ISE / blood gas</strong> and check measured osmolality before treating.</div>';
          }

          // ---- metrics ----
          html+='<div class="metrics">';
          html+='<div class="metric"><div class="k">Total body water</div><div class="val">'+fmt(TBW)+' <small>L</small></div><div class="note">'+w+' kg × '+tbwf+'</div></div>';

          if(status==="hyper"){
            var fwd = TBW*((corrNa/sp.high)-1); // deficit to high-normal
            var fwdMid = TBW*((corrNa/((sp.low+sp.high)/2))-1);
            html+='<div class="metric"><div class="k">Free water deficit</div><div class="val">'+fmt(fwd)+' <small>L</small></div><div class="note">to Na⁺ '+sp.high+' · '+fmt(fwdMid)+' L to mid-normal</div></div>';
          } else if(status==="hypo"){
            var naDefToLow = TBW*(sp.low-corrNa);
            html+='<div class="metric"><div class="k">Na⁺ deficit</div><div class="val">'+fmt(naDefToLow,0)+' <small>mmol</small></div><div class="note">to reach Na⁺ '+sp.low+' (total, not 24 h)</div></div>';
          } else {
            html+='<div class="metric"><div class="k">Status</div><div class="val" style="font-size:16px;color:var(--ok)">In range</div><div class="note">No correction indicated</div></div>';
          }
          html+='</div>';

          // ---- safe rate + plan (only if abnormal) ----
          if(status!=="normal"){
            var maxDaily = 12;                 // conservative default mmol/L / 24h
            if(state.acuity==="chronic") maxDaily = (status==="hypo"?8:10);
            else maxDaily = (status==="hypo"?10:12); // acute a little more latitude, still cautious
            var maxHourly = 0.5;               // mmol/L / hr ceiling

            // auto 24h target (do not overshoot into/through normal)
            var autoTarget;
            if(status==="hyper"){
              autoTarget = Math.max(corrNa - maxDaily, sp.high); // don't drop below high-normal in 24h
            }else{
              autoTarget = Math.min(corrNa + maxDaily, sp.low);  // don't rise above low-normal in 24h
            }
            var target = num(targetEl);
            if(target===null) target = autoTarget;

            var deltaTarget = target - corrNa;          // signed desired change over window
            var deltaAbs = Math.abs(deltaTarget);
            var ratePerHr = deltaAbs/hours;             // planned mmol/L/hr

            // Adrogué–Madias for chosen fluid
            var f=fluidById(state.fluid);
            var dNaPerL = (f.na + f.k - corrNa)/(TBW+1);   // mmol/L change per litre infused
            var fluidNote="", fluidOK=true, volNeeded=null, mlhr=null;
            if(Math.abs(dNaPerL) < 0.001){
              fluidNote="This fluid is iso-natraemic to the patient (ΔNa⁺ ≈ 0/L) — it will not move Na⁺. Pick a fluid on the correct side.";
              fluidOK=false;
            } else {
              var sameDir = (deltaTarget>0 && dNaPerL>0) || (deltaTarget<0 && dNaPerL<0);
              if(!sameDir){
                fluidNote="Wrong direction: this fluid pushes Na⁺ "+(dNaPerL>0?"up":"down")+", but you need it to go "+(deltaTarget>0?"up":"down")+". Choose a different fluid.";
                fluidOK=false;
              } else {
                volNeeded = deltaTarget/dNaPerL;           // litres over the window
                mlhr = (volNeeded*1000)/hours;
                fluidNote="At this rate the fluid alone is predicted to move Na⁺ by "+fmtSigned(dNaPerL,2)+" mmol/L per litre. Ongoing losses and maintenance are <em>not</em> included.";
              }
            }

            // verdict on planned rate
            var rateClass = ratePerHr>maxHourly?"red":"teal";
            var rateMsg = ratePerHr>maxHourly
              ? "Planned rate "+fmt(ratePerHr,2)+" mmol/L/hr exceeds the 0.5 mmol/L/hr ceiling — lengthen the window."
              : "Planned rate "+fmt(ratePerHr,2)+" mmol/L/hr is within the ≤0.5 mmol/L/hr ceiling.";

            // safe-rate metric row
            html+='<div class="metrics">';
            html+='<div class="metric"><div class="k">Max safe change / 24 h</div><div class="val">'+maxDaily+' <small>mmol/L</small></div><div class="note">'+(state.acuity==="chronic"?"chronic/unknown":"acute")+' · '+(status==="hypo"?"rise":"fall")+'</div></div>';
            html+='<div class="metric"><div class="k">24 h safe target</div><div class="val">'+fmt(target)+' <small>mmol/L</small></div><div class="note">'+(num(targetEl)===null?"auto — capped at "+(status==="hyper"?"high":"low")+"-normal":"manual override")+'</div></div>';
            html+='</div>';

            // plan table
            html+='<table class="plan"><tbody>';
            html+='<tr><td>Direction &amp; total move to target</td><td class="num">'+fmtSigned(deltaTarget)+' mmol/L</td></tr>';
            html+='<tr><td>Planned change over '+fmt(hours,0)+' h</td><td class="num">'+fmt(ratePerHr,2)+' mmol/L/hr</td></tr>';
            html+='<tr><td>Fluid selected</td><td class="num">'+f.name.replace(/ —.*/,"")+'</td></tr>';
            html+='<tr><td>Predicted ΔNa⁺ per litre</td><td class="num">'+fmtSigned(dNaPerL,2)+' mmol/L</td></tr>';
            if(fluidOK && volNeeded!==null){
              html+='<tr><td>Volume over '+fmt(hours,0)+' h (this fluid only)</td><td class="num">'+fmt(volNeeded*1000,0)+' mL</td></tr>';
              html+='<tr><td>Approx. infusion rate</td><td class="num">'+fmt(mlhr,0)+' mL/hr &nbsp;('+fmt(mlhr/w,1)+' mL/kg/hr)</td></tr>';
            }
            html+='</tbody></table>';

            html+='<div class="callout '+rateClass+'"><strong>'+rateMsg+'</strong><br><span style="font-size:12.5px">'+fluidNote+'</span></div>';

            if(!fluidOK){
              html+='<div class="callout red"><strong>Fluid choice needs changing.</strong> For '+(status==="hyper"?"hypernatraemia lower Na⁺ using 0.45% NaCl, 0.18%/4% dextrose or D5W. Add free water (oral/enteral) where safe.":"hyponatraemia raise Na⁺ using 0.9% NaCl, or 3% NaCl for acute symptomatic cases.")+'</div>';
            }

            // acute symptomatic guidance
            if(state.acuity==="acute"){
              if(status==="hypo"){
                html+='<div class="callout amber"><strong>Acute symptomatic hyponatraemia.</strong> If seizing or obtunded, a small bolus of 3% NaCl (≈3–4 mL/kg over 10–20 min, repeat once if needed) can raise Na⁺ by ~4–6 mmol/L to break the crisis — then revert to the slow ceiling above. Never chase full normalisation acutely.</div>';
              }else{
                html+='<div class="callout amber"><strong>Acute hypernatraemia (&lt;48 h).</strong> If genuinely acute (e.g. salt toxicity, rapid free-water loss), a faster fall of up to ~1 mmol/L/hr may be acceptable. If in any doubt about duration, treat as chronic and cap at 0.5 mmol/L/hr.</div>';
              }
            }

            // universal monitoring reminder
            html+='<div class="callout"><strong>Recheck Na⁺ every 2–4 h</strong> and titrate to the measured trend — these numbers are a starting estimate, not a fixed prescription. Treat the underlying cause. Watch for over-correction: '+(status==="hypo"?"osmotic demyelination if Na⁺ rises too fast":"cerebral oedema / seizures if Na⁺ falls too fast")+'.</div>';
          } else {
            html+='<div class="callout teal">Sodium is within the '+sp.label.toLowerCase()+' reference range, so no correction plan is generated. If clinical signs persist, review osmolality, glucose and the primary disease process rather than the Na⁺ number.</div>';
          }

          outEl.innerHTML=html;
        }

        render();
    }
  }
  if (!customElements.get("s-sodium-correction-calculator")) customElements.define("s-sodium-correction-calculator", SodiumCorrectionCalculator);
})();
